export const PROJECT_INFORMATION_MAX_NUMBER = 9999;
export const PROJECT_INFORMATION_MIN_NUMBER = 1;
export const PROJECT_NAME_MAX_LENGTH = 50;
export const CPM_PROJECT_ID_MAX_LENGTH = 30;
export const CONDOMINIUM_COOPERATIVE_PHASE_MAX_LENGTH = 50;
